<template>
  <div>
    <!-- BAND COLOR -->
    <div class="row justify-content-center" v-if="!customband.hasMultipleItems()">
      <div class="col col-lg-3">
        <colors-select :colors="customband.getProductColors()" :color-value="customband.customization.rows[0].color1" :color-required="true" label="Color" :show-label="false" :is-print-color="false" :hide-label-on-mobile="true"></colors-select>
      </div>
      <div class="col col-lg-3" v-if="customband.product.manifest.colorContainers.color_1 && customband.product.manifest.type != 'Dual Layer'">
        <colors-select :colors="customband.getProductColors()" :color-value="customband.customization.rows[0].color2" :color-required="true" label="Color" :show-label="false" :is-print-color="false"  :hide-label-on-mobile="true"></colors-select>
      </div>
      <div class="col col-lg-3" v-if="customband.product.manifest.colorContainers.color_2 && customband.product.manifest.type != 'Dual Layer'">
        <colors-select :colors="customband.getProductColors()" :color-value="customband.customization.rows[0].color3" :color-required="true" label="Color" :show-label="false" :is-print-color="false" :hide-label-on-mobile="true"></colors-select>
      </div>
    </div>

    <!-- PHRASES -->
    <div v-for="(area, areaIndex) in customband.customization.areas">
      <div class="card bb-card">
        <div class="card-header">
          <div class="row no-gutters">
            <div class="col d-flex align-items-center">
              <h5 class="m-0">{{ area.label }}<small v-if="areaIndex === 1" style="text-transform: none;"> (optional)</small></h5>
              <div class="pricing ml-2" v-if="areaIndex === 1">
                <pricing :tiers="customband.getExtraPhrasePricingTiers()" :type="'phrase'" :btn-text="'Extra Side Pricing'" v-if="!noPhrase"></pricing>
              </div>
            </div>
            <div class="col-md-3 col-lg-auto">

            </div>
            <div class="col-md-3 col-lg-2 d-none d-md-flex">
              <pricing class="ml-2" :tiers="customband.getPrintColorPricingTiers(areaIndex)" :type="'color_fill'" :btn-text="'Text Color Pricing'" v-if="customband.getPrintColorPricingTiers(areaIndex)"></pricing>
            </div>
          </div>
        </div>
        <div class="card-body">
          <phrase v-for="p in area.texts" :key="p._path" :phrase="p"></phrase>
        </div>
      </div>

    </div>

    <steps-bar></steps-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import _get from 'lodash/get'

  let stateName = 'bandbuilder.silicone.text'

  export default {
    data: () => ({
      sheet: false,
      tiles: [
        { img: 'keep.png', title: 'Keep' },
        { img: 'inbox.png', title: 'Inbox' },
        { img: 'hangouts.png', title: 'Hangouts' },
        { img: 'messenger.png', title: 'Messenger' },
        { img: 'google.png', title: 'Google+' }
      ]
    }),
    computed: {
      noPhrase () {
        return !this.customband.hasTexts()
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },
    methods: {
      firstTextHasColorFill (area) {
        return _get(area, 'manifest.texts.0.colorFill', null)
      }
    },

    created () {
      // console.log('customband', this.customband)

      this.$store.dispatch('customstates/stepIsCompleted', stateName)
      this.$store.dispatch('customband/checkCompletion')
    },

    mounted () {
      // console.log('customband', this.customband)
      // console.log('this._params', this._params)
      // console.log('this.$route', this.$route)
      // console.log('this.customband.isPrinted()', this.customband.isPrinted())
    }
  }
</script>
